import {isEmpty, pathOr} from "ramda";
import {BasicEntityInfo} from "../api/entity";
import {ConnectionRole, Locale} from "../enums";
import {EntityFeature} from "../enums/entity";
import {extractEmailDomain} from "../utils";
export function isCustomizedConnectionRole(entity: any, connectionRole: string | null): boolean {
  if (!connectionRole) {
    return false;
  }
  const isBuyerType = pathOr([], ["buyerTypes"], entity).findIndex((t) => connectionRole === t.value) > -1;
  const isSellerType = pathOr([], ["sellerTypes"], entity).findIndex((t) => connectionRole === t.value) > -1;
  return isBuyerType || isSellerType;
}

export function getCustomizedConnectionRoleLabelWithFallback(
  entity: any, // EntityInstance
  connectionRole: string,
  locale: Locale = Locale.EN_US,
): string {
  const hasBuyer = entity.buyerTypes?.findIndex((t) => connectionRole === t.value);
  if (hasBuyer > -1) {
    return entity.buyerTypes[hasBuyer].label[locale];
  } else {
    const hasSeller = entity.sellerTypes?.findIndex((t) => connectionRole === t.value);
    if (hasSeller > -1) {
      return entity.sellerTypes[hasSeller]?.label[locale];
    }
  }
  return `connection.${connectionRole}`;
}

export function getFallBackConnectionRole(entity: any, connectionRole: string): string {
  if (isCustomizedConnectionRole(entity, connectionRole)) {
    if (pathOr([], ["buyerTypes"], entity).findIndex((t) => connectionRole === t.value) > -1) {
      return ConnectionRole.BUYER;
    } else {
      return ConnectionRole.SELLER;
    }
  }
  return connectionRole;
}

export function hasFeature(feature: EntityFeature, entity: BasicEntityInfo) {
  return !isEmpty(entity?.features) && !!entity?.features?.[feature];
}

export function userEntityDomainCheck(email: string, adminDomains: string[], badDomains: string[]): boolean {
  const emailDomain = extractEmailDomain(email);
  if (!emailDomain) {
    return false;
  }
  return !badDomains.includes(emailDomain) && adminDomains.includes(emailDomain);
}

export const GraphiteCompanyPublicId = "US1205";
